import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const CampaignList = Loadable(
  lazy(() => import("features/campaign/components/List"))
);
const CampaignForm = Loadable(
  lazy(() => import("features/campaign/components/Form"))
);
const CustomCampaignForm = Loadable(
  lazy(() => import("features/campaign/components/CustomCampaignForm"))
);
const WhatsAppCampaign = Loadable(
  lazy(() => import("features/campaign/components/WhatsAppCampaign"))
);

const routes = {
  path: "campaign",
  children: [
    { path: "", element: <CampaignList /> },
    { path: "whatsapp", element: <WhatsAppCampaign /> },
    { path: "addmemberschedular", element: <CustomCampaignForm /> },
    { path: "addadminschedular", element: <CustomCampaignForm /> },
    { path: "edit/:id?", element: <CustomCampaignForm /> },
  ],
};

export default routes;
